/**
 *  GetAllNewestByIDs 系：　仮に存在しないIDを渡されてもエラーにはならずに、存在するデータが戻る
 *  GetAllByIDs系：　存在しないIDが一つでも入っていれば全体として404が戻る
 */
export interface IApplyClientRepository {
  register(registerClientRequest: TRegisterClientRequest): Promise<void>;
}

export type TRegisterClientRequest = {
  email: string;
  phoneNumber: string;
  companyName: string;
  webURL: string;
  accountName: string;
  accountNameKana: string;
  department: string;
  position: string;
  source: Source;
  isDemo: boolean;
  demoPassword: string;
  routeInfo: string;
};

export enum Source {
  Source_Unknown = 0,
  Source_Internal = 1,
  Source_Lafool = 2,
  Source_LafoolMedical = 3,
}



// WEBPACK FOOTER //
// ./src/domain/repository/apply_client_repository.ts